export const setShowSidebar = 'setShowSidebar';
export const setRefreshApp = 'setRefreshApp';
export const setPusherSubscriptionChannels = 'setPusherSubscriptionChannels';
